const data = [
  {
    name: 'Peace Generation Indonesia',
    image: 'khub_peacegen.svg',
    type: 'Non-Profit Organization',
    since: '2007',
    approach: 'Pencegahan',
    location: 'Bandung',
    issues: 'Pemuda, Pelajar'
  },
  {
    name: 'Filantropi Indonesia',
    image: 'khub_filantropi.svg',
    type: 'Non-Profit Organization',
    since: '2007',
    approach: 'Intervention',
    location: 'Jakarta, Surabaya, Poso',
    issues: 'Students'
  },
  {
    name: 'Convey Indonesia',
    image: 'khub_convey.svg',
    type: 'Non-Profit Organization',
    since: '2007',
    approach: 'Intervention',
    location: 'Jakarta, Surabaya, Poso',
    issues: 'Students'
  },
  {
    name: 'Aksi Cepat Tanggap',
    image: 'khub_act.svg',
    type: 'Non-Profit Organization',
    since: '2007',
    approach: 'Intervention',
    location: 'Jakarta, Surabaya, Poso',
    issues: 'Students'
  },
  {
    name: 'Peace Generation Indonesia',
    image: 'khub_peacegen.svg',
    type: 'Non-Profit Organization',
    since: '2007',
    approach: 'Pencegahan',
    location: 'Bandung',
    issues: 'Pemuda, Pelajar'
  },
  {
    name: 'Filantropi Indonesia',
    image: 'khub_filantropi.svg',
    type: 'Non-Profit Organization',
    since: '2007',
    approach: 'Intervention',
    location: 'Jakarta, Surabaya, Poso',
    issues: 'Students'
  },
]

export default data